export enum LoaderButtonState {
  LOADING = 'c-loader-button--loading',
  DONE = 'c-loader-button--done',
  FAILED = 'c-loader-button--failed',
  NORMAL = '',
  NONE = ''
}
